import "./index.scss";

const Modal = ({ onClose, children}) => {


  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="button-close">Fechar</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
